import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import { Box, Paragraph, Text, TextInput, Button } from 'grommet';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { VerifyOtpMerchantCtrl } from '../Controllers/Account/Registrazione/VerifyOtpMerchantCtrl.js';
import { VerifyOtpPVCtrl } from '../Controllers/Account/Registrazione/VerifyOtpPVCtrl.js';
import { ValidateMerchantCtrl } from '../Controllers/Account/Registrazione/ValidateMerchantCtrl.js';
import { ValidatePVCtrl } from '../Controllers/Account/Registrazione/ValidatePVCtrl.js';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
import { loader, logout } from '../Utils/Utility';


class Error extends React.Component {

    render() {

        return (
            <Box>
                <Text className='error'>{this.props.testo}</Text>
            </Box>
        );
    }
}


class InsertOTPReg extends Component {
    constructor(props) {
        super(props);
        this.state = {
            otpCode: '',
            disableButton: true,
            status: '',
            otpError: false,
            loading: false,
            showTimeoutModal: false,
            errorMsg: '',
        }
        this.setOTP = this.setOTP.bind(this);
        this.goToLogin = this.goToLogin.bind(this);
        this.goToOTP = this.goToOTP.bind(this);
    }

    setOTP(e) {
        this.setState({
            otpCode: e.target.value
        }, function () {
            var otpRegex = /^[0-9]+$/;
            var otpTest = otpRegex.test(this.state.otpCode)
            if (this.state.otpCode.length === 6 && otpTest) {
                this.setState({
                    disableButton: false,
                    otpError: false,
                    errorMsg: ''
                })
            }
            else if (this.state.otpCode.length < 6 && otpTest) {
                this.setState({
                    disableButton: true,
                    otpError: false,
                    errorMsg: ''
                })
            } else {
                this.setState({
                    disableButton: true,
                    otpError: true,
                    errorMsg: 'Inserire il numero di 6 cifre inviato via sms'
                })
            }
        })
    }

    goToLogin() {
        var ids = sessionStorage.getItem('ids')
        const self = this
        if (this.props.location.code === 'society') {

            this.setState({
                loading: true
            });

            VerifyOtpMerchantCtrl(function (data, status) {
                self.setState({
                    data: data,
                    status: status,
                    loading: false
                }, function () {
                    if (status === 200) {
                        this.props.history.push({
                            pathname: '/RegistrationResult',
                            state: this.state,
                            code: 'society',
                            step: 4
                        })
                    }
                });

            }, function (status, error) {
                self.setState({
                    status: status,
                    loading: false
                }, function () {
                    if (status === 500 || status === 400 || status === 404 || status === 403) {
                        this.props.history.push({
                            pathname: '/RegistrationResult',
                            state: this.state,
                            code: 'society'
                        })
                    } else if (status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                    } else if (status === 406 && error === '5704') {
                        this.setState({
                            errorMsg: 'Codice OTP scaduto',
                            otpError: true
                        })
                    }  else if (status === 406 && error === '5707') {
                        this.setState({
                            otpError: true,
                            errorMsg: 'Codice OTP non valido'
                        })
                    } else if (status === 406 && error === '5708') {
                        this.setState({
                            otpError: true,
                            errorMsg: 'Ultimo tentativo prima del blocco utenza'
                        })
                    } else if (status === 406 && error === '5709') {
                        this.setState({
                            otpError: true,
                            errorMsg: 'Utenza bloccata'
                        })
                        logout();
                    } else {
                        self.setState({
                            msgOtp: 'Si è verificato un errore, riprovare!',
                            errorOtp: true
                        })
                    }
                })
            }, this.state, ids, this.props.location.state.username);

        } else {

            this.setState({
                loading: true
            });

            VerifyOtpPVCtrl(function (data, status) {
                self.setState({
                    data: data,
                    status: status,
                    loading: false
                }, function () {
                    if (status === 200) {
                        this.props.history.push({
                            pathname: '/RegistrationResult',
                            state: this.state,
                            code: 'shop',
                            step: 4
                        })
                    }
                });

            }, function (status, error) {
                self.setState({
                    status: status,
                    loading: false
                }, function () {
                    if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                        this.props.history.push({
                            pathname: '/RegistrationResult',
                            state: this.state,
                            code: 'shop'
                        })
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                    }  else if (status === 406 && error === '5704') {
                        this.setState({
                            errorMsg: 'Codice OTP scaduto',
                            otpError: true
                        })
                    } else if (status === 406 && error === '5707') {
                        this.setState({
                            otpError: true,
                            errorMsg: 'Codice OTP non valido'
                        })
                    } else if (status === 406 && error === '5708') {
                        this.setState({
                            otpError: true,
                            errorMsg: 'Ultimo tentativo prima del blocco utenza'
                        })
                    } else if (status === 406 && error === '5709') {
                        this.setState({
                            otpError: true,
                            errorMsg: 'Utenza bloccata'
                        })
                        logout();
                    } else {
                        self.setState({
                            msgOtp: 'Si è verificato un errore, riprovare!',
                            errorOtp: true
                        })
                    }
                })
            }, this.state, ids, this.props.location.state.username);
        }
    }

    goToOTP() {
        var ids = sessionStorage.getItem('ids')
        const self = this;
        
        this.setState({
            loading: true
        });
        
        if (this.props.location.code === 'society') {
            ValidateMerchantCtrl(function (data, status) {
                self.setState({
                    data: data,
                    status: status,
                    loading: false
                });

            }, function (error) {
                self.setState({
                    status: error,
                    loading: false
                }, function () {
                    if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                        this.props.history.push({
                            pathname: '/ErrorPageReg',
                            state: this.state,
                            code: 'society',
                            numtel: this.props.location.state.numtel
                        })
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                    }
                })

            }, this.props.location.state, ids);
        } else {
            ValidatePVCtrl(function (data, status) {
                self.setState({
                    data: data,
                    status: status,
                    loading: false
                });

            }, function (error) {
                self.setState({
                    status: error,
                    loading: false
                }, function () {
                    if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                        this.props.history.push({
                            pathname: '/ErrorPageReg',
                            state: this.state,
                            code: 'shop',
                            numtel: this.props.location.state.numtel
                        })
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                    }
                })

            }, this.props.location.state, this.props.location.email, ids);
        }
    }

    componentWillMount() {
        if (this.props.location.step !== 3) {
            this.props.history.push({
                pathname: '/login'
            })
        }
    }

    render() {
        return (
            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Header />

                <Box direction="column" align='center' className='background-color'>
                    <Box direction='row' >
                        <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>Abbiamo quasi finito!</h1>
                        <Text className='titlehome' style={{ marginBottom: '5px' }}></Text>
                    </Box>
                    <Box direction='row'>
                        <Paragraph className='textParagraph' style={{ textAlign: 'center', margin:'0px 70px' }}> Per procedere alla certificazione del numero di telefono cellulare inserisci di seguito l'OTP che ti abbiamo mandato via sms al numero {this.props.location.numtel}</Paragraph>
                    </Box>


                    <Box direction='column' style={{ margin: '30px 0 50px' }}>
                        <Text className='label'>CODICE OTP</Text>
                        <TextInput id='otp' size='medium' className={`inputFormdisp ${this.state.errorMsg ? 'errorBoxInput' : '' }`} onChange={this.setOTP} maxLength={6} />
                        {this.state.otpError ? <Error testo={this.state.errorMsg} /> : ''}
                    </Box>


                    <Box className='informativa' align='center'>
                        <Button className='btnform' label='REINVIA CODICE' onClick={this.goToOTP} />
                        <Box>&nbsp;</Box>
                        <Button className={this.state.disableButton ? 'btnform disabled' : 'btnform'} label='CONFERMA CODICE' disabled={this.state.disableButton} onClick={this.goToLogin} />
                    </Box>
                    {this.state.loading ? loader : ''}
                </Box>
                <Footer />
            </Box >
        )
    }
}


export default InsertOTPReg = withRouter(InsertOTPReg)